<template>
  <div class="auto-input-container">
    <el-input type="text" :size="props.size" :placeholder="props.placeholder" :autofocus="props.autofocus" :name="props.name" :disabled="props.disabled" :class="props.class" v-model.trim="inputValue" @keyup="handleKeyup" @blur="handleBlur" />
    <div class="auto-list" v-if="autoListShow && autoList.length > 0">
      <ul>
        <li v-for="(item, index) in autoList" :key="index" :class="{ active: index === selectIndex }" class="text-overflow" @click="handleSelectItem(index)">
          {{ item.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { getCommonEmailDomains } from '@/api/user/user'
import { computed, onMounted, reactive, ref, watch } from 'vue'

const props = defineProps({
  placeholder: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: 'auto-input',
  },
  disabled: {
    // 是否禁止修改
    type: Boolean,
    default: false,
  },
  type: {
    // 输入框类型：account=>用户账号
    type: String,
    default: 'account',
  },
  maxLength: {
    // 下拉最多显示的数量
    type: Number,
    default: 8,
  },
  class: {
    // input 自定义 class
    type: String,
    default: '',
  },
  autofocus: {
    type: Boolean,
    default: true,
  },
  size: {
    type: String,
    default: 'large'
  }
})
const emits = defineEmits(['on-change'])
const originAutoList = reactive([]) // 下拉列表后缀，原始数据
const splitStr = ref('@')
const handleGetOriginAutoList = async () => {
  // 获取下拉列表后缀
  originAutoList.splice(0, originAutoList.length)
  if (props.type === 'account') {
    const { data } = await getCommonEmailDomains()
    originAutoList.push(...data)
  }
}
const autoListShow = ref(false) // 下拉是否显示
const inputValue = defineModel({ default: '' }) // 输入的值
const autoList = computed(() => {
  // 下拉列表
  const inputVal = inputValue.value
  let prefixInputVal = inputVal
  // 是否已经输入了分隔符
  let hasInputSplitStr
  if (isNaN(inputVal)) {
    hasInputSplitStr = inputVal.includes(splitStr.value)
  }
  if (isNaN(inputVal) && hasInputSplitStr) {
    prefixInputVal = inputVal.split(splitStr.value)[0]
  }

  // const inputNewValue = props.inputValue ? props.inputValue : inputValue
  // console.log(inputNewValue);
  const res = originAutoList.map(item => {
    const currentItem = {
      label: '',
      value: '',
    }
    if (item instanceof Object) {
      currentItem.label = `${prefixInputVal}${splitStr.value}${item.label || ''}`
      currentItem.value = `${prefixInputVal}${splitStr.value}${item.value || ''}`
    } else {
      currentItem.label = `${prefixInputVal}${splitStr.value}${item}`
      currentItem.value = `${prefixInputVal}${splitStr.value}${item}`
    }
    return currentItem
  })
  if (isNaN(inputVal) && hasInputSplitStr) {
    const regexp = new RegExp(`^${inputVal}`, 'i')
    return res.filter(item => regexp.test(item.value)).slice(0, props.maxLength)
  }
  return res.slice(0, props.maxLength)
})
const selectIndex = ref(-1)

watch(
  () => autoList.value,
  () => {
    if (autoList.value.length > 0) {
      selectIndex.value = 0
    } else {
      selectIndex.value = -1
    }
  }
)
watch(
  () => inputValue.value,
  newVal => {
    inputValue.value = newVal.trim()
    emits('on-change', newVal)
  }
)
const handleBlur = () => {
  setTimeout(() => {
    autoListShow.value = false
  }, 300)
}
// 点击下拉选择
const handleSelectItem = index => {
  inputValue.value = autoList.value[index].value
  autoListShow.value = false
  selectIndex.value = -1
  document.getElementsByName(props.name)[0].focus()
}
// 上下键和确认键
const handleKeyup = event => {
  const key = event.key
  if (key === 'ArrowDown') {
    if (selectIndex.value < autoList.value.length - 1) selectIndex.value++
  } else if (key === 'ArrowUp') {
    if (selectIndex.value > 0) selectIndex.value--
  } else if (key === 'Enter' && autoList.value.length > 0) {
    if (autoListShow.value) {
      inputValue.value = autoList.value[selectIndex.value].value
      autoListShow.value = false
      selectIndex.value = -1
      event.stopPropagation()
    }
  } else {
    // 输入分隔符时，显示下拉
    autoListShow.value = inputValue.value.indexOf(splitStr.value) > 0
  }
}
onMounted(() => {
  handleGetOriginAutoList()
})
</script>

<style lang="scss" scoped>
.auto-input-container {
  position: relative;
  width: 101%;
  .auto-list {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(53, 53, 53, 0.16);
    backdrop-filter: blur(4px);
    border-radius: 6px;
    padding: 0 4px;
    box-sizing: border-box;
    z-index: 10;
    ul {
      li {
        list-style-type: none;
        cursor: pointer;
        margin: 4px 0;
        border-radius: 4px;
        padding: 6.5px 8px;
        // font-size: 12px;
        font-size: 14px;
        line-height: 14px;
        transition: all 0.5s;
        box-sizing: border-box;
        position: relative;
        &::after {
          content: ' ';
          display: block;
          width: 100%;
          border-bottom: 1px solid rgba(53, 53, 53, 0.08);
          position: absolute;
          top: calc(100% + 2px);
          left: 0;
        }
        &:hover,
        &.active {
          background: rgba(53, 53, 53, 0.06);
        }
        &:last-child {
          &::after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.ar-SA {
  .auto-list {
    ul {
      li {
        text-align: right;
      }
    }
  }
}
</style>
